import { Container } from 'react-bootstrap';
import SimpleAccordion from './SimpleAccordion';

const milestonesData = {
  title: 'Earliest Retirement',
  date: '20/30/30',
  age: 50,
  firstSubTitle: {
    title: 'Qualified Pension Plan',
    amount: 40.22,
    plans: [
      { title: 'Plan 1', amount: 23.3 },
      { title: 'Plan 2', amount: 1.9 },
      { title: 'Plan 3', amount: 15.02 },
    ],
  },
  secondSubTitle: { title: 'Non-Qualified Pension Plan ', amount: 42331.2 },
};

const SimpleAccordionDemo = () => {
  return (
    <>
      <Container className="mx-5">
        <h4 className="mt-13">Vertical Steps</h4>
        <SimpleAccordion props={milestonesData} />
      </Container>
    </>
  );
};

export default SimpleAccordionDemo;
